import React from 'react';
import C from '../../constants/colors';

export default function StatusDot({ status, size = 10 }) {
  const colors = { SAFE: C.green, NEED_HELP: C.red, NOT_RESPONDED: C.amber, EVACUATED: C.textSecondary };
  const color = colors[status] || C.textMuted;
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {status === 'NEED_HELP' && (
        <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: C.red, opacity: 0.5, animation: 'pulse-ring 1.2s infinite' }} />
      )}
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: color }} />
    </div>
  );
}
